/**
 * This file was auto-generated by Fern from our API Definition.
 */

import * as Truvity from '../../api/index';
import * as core from '../../core';
import * as serializers from '../index';

export const ErrorDetail: core.serialization.ObjectSchema<serializers.ErrorDetail.Raw, Truvity.ErrorDetail> =
    core.serialization.object({
        location: core.serialization.string().optional(),
        message: core.serialization.string().optional(),
        value: core.serialization.unknown().optional(),
    });

export declare namespace ErrorDetail {
    export interface Raw {
        location?: string | null;
        message?: string | null;
        value?: unknown | null;
    }
}
